import { combineReducers } from "redux";

import ResourceManagers from "src/resources";

export const resourcesReducers = combineReducers({
  events: ResourceManagers.events.reducer
});
